module.exports = __webpack_public_path__ + "images/header-logo-spirit-loading.87e1af770a49ce8e84e3.gif";